import React from "react";

export const GleamPanel = ({ height, darker, className, style }) => {
  return (
    <div
      style={{ height, ...style }}
      className={
        "gleam " +
        (darker ? "gleam-darker" : "") +
        (className ? " " + className : "")
      }
    ></div>
  );
};
